import { connect } from "react-redux";
import authAction from "../../auth/auth.actions";
import layoutActions from "../layout/layout.actions";
import profileActions from "./profile.actions";
import profileReducers from "./profile.reducers";

export default (Component) => {
    return connect(profileReducers, { ...profileActions, ...layoutActions, ...authAction })(Component);
};